export const PAGINATION_CONTROL_HEIGHT = 34;
export const INPUT_WIDTH = 140;
